<template>
  <basic-content>
    <a-row slot="content">
      <agent />
    </a-row>
  </basic-content>
</template>

<script>
import BasicContent from '@/layout/BasicContent.vue'
import Agent from '@/com/Agent/Agent.vue'

export default {
  name: 'AgentMain',
  data() {
    return {
      tab: 'agent',
    }
  },
  components: {
    BasicContent,
    Agent
  },
  created() {
    this.$store.commit('changetab', this.tab)
  }
}
</script>

<style scoped>
</style>

